/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Success_TextInputs */

const en_iframe_remote_success_text = /** @type {(inputs: Iframe_Remote_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project import successful.`)
};

const fr_iframe_remote_success_text = /** @type {(inputs: Iframe_Remote_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du projet reussie.`)
};

const de_iframe_remote_success_text = /** @type {(inputs: Iframe_Remote_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektimport erfolgreich.`)
};

const it_iframe_remote_success_text = /** @type {(inputs: Iframe_Remote_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione del progetto riuscita.`)
};

const ru_iframe_remote_success_text = /** @type {(inputs: Iframe_Remote_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт проекта пройден успешно.`)
};

const es_iframe_remote_success_text = /** @type {(inputs: Iframe_Remote_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación del proyecto exitosa.`)
};

const zh_cn2_iframe_remote_success_text = /** @type {(inputs: Iframe_Remote_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目导入成功。`)
};

const ja_iframe_remote_success_text = /** @type {(inputs: Iframe_Remote_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトのインポートに成功しました。`)
};

const hi_iframe_remote_success_text = /** @type {(inputs: Iframe_Remote_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट का आयात सफलतापूर्वक हो गया है।`)
};

const pt_pt2_iframe_remote_success_text = /** @type {(inputs: Iframe_Remote_Success_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação do projeto concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Project import successful." |
*
* @param {Iframe_Remote_Success_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_success_text = /** @type {((inputs?: Iframe_Remote_Success_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Success_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_success_text(inputs)
	if (locale === "de") return de_iframe_remote_success_text(inputs)
	if (locale === "it") return it_iframe_remote_success_text(inputs)
	if (locale === "ru") return ru_iframe_remote_success_text(inputs)
	if (locale === "es") return es_iframe_remote_success_text(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_success_text(inputs)
	if (locale === "ja") return ja_iframe_remote_success_text(inputs)
	if (locale === "hi") return hi_iframe_remote_success_text(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_success_text(inputs)
	return en_iframe_remote_success_text(inputs)
});